import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import dayjs from "dayjs";
import {
  View,
  ScrollView,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  Dimensions,
  Alert,
} from "react-native";
import TouchableOpacity from "app/components/TouchableOpacity";
import Text from "app/components/Text";
import chapterActions from "app/utils/chapterActions";
import storageActions from "app/utils/storageActions";
import valueActions from "app/utils/valueActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import colorHelpers from "app/utils/colorHelpers";
import timeHelpers from "app/utils/timeHelpers";

import DatePicker from "app/components/DatePicker";
import MomentBullet from "app/components/chapter/MomentBullet";
import MomentList from "app/components/chapter/MomentList";
import Chapter from "app/components/Chapter";
import Icon from "app/components/Icon";
import Badge from "app/components/chapter/Badge";
import Autocomplete from "app/components/Autocomplete";
import AreaGraph from "app/components/AreaGraph";

import store from "app/redux/store";
import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class Waves extends React.Component {
  static contextType = StyleContext;
  constructor(props, context) {
    super(props, context);
    let { navigation, route } = this.props;

    this.state = {
      chapters: [],
      moments: [],
      values: [],
      nestedValues: [],
      // loading: true,
      graphValueIds: [],
      graphValues: [],
      query: "",
      focusedValueId: null,
      selectedValueIds: [],
      excludeValueIds: [],
      startAt: dayjs().subtract(5, "weeks").valueOf(),
      endAt: dayjs().add(1, "week").valueOf(),
    };
  }

  async componentDidMount() {
    // this.fetch();
    this.fetchFromValueIds();
  }

  fetchFromValueIds = async () => {
    let selectedValueIds = await storageActions.fetchItem(
      "waves_selected_values",
    );
    let excludeValueIds = await storageActions.fetchItem(
      "waves_excluded_values",
    );
    if (!!selectedValueIds?.length || !!excludeValueIds?.length) {
      await this.setState({ selectedValueIds, excludeValueIds });
      this.fetch();
    }
  };

  fetch = async (tryLocal = true, showLoading = true) => {
    let { selectedValueIds, excludeValueIds } = this.state;
    if (showLoading) this.setState({ loading: true });
    let res;
    if (tryLocal) {
      res = await storageActions.fetchItem("waves_res");
      this.fetch(false, false); // fetch from server in background
      console.log("local res?", res);
    }
    if (!res || !tryLocal) {
      res = await chapterActions.waves(selectedValueIds, excludeValueIds);
      storageActions.saveItem("waves_selected_values", selectedValueIds);
      storageActions.saveItem("waves_excluded_values", excludeValueIds);
      storageActions.saveItem("waves_res", res);
      let local = await storageActions.fetchItem("waves_res");
      console.log("ok local now?", local);
    }
    console.log(res);
    // let values = res.values
    let { values, moments, chapters, parents, grand_parents, start_at } = res;
    // let values = [...values, ...parents, ...grand_parents];
    values = [...values, ...parents];
    let topLevelIds = this.getTopLevelIds(values);
    let nestedValues = this.nestValues(values, moments, topLevelIds);
    let graphValues = nestedValues.map((v) => ({
      value: v,
      moments: v.supportingMoments,
    }));
    this.setState({
      loading: false,
      startAt: res.start_at,
      chapters: res.chapters,
      moments: res.moments,
      values,
      topLevelIds,
      nestedValues,
      graphValues,
    });
    // } else {
    //   let error = res?.error || "error";
    //   console.warn(error);
    // }
  };

  removeGraphValue = async (id) => {
    let {
      graphValues,
      graphValueIds,
      selectedValueIds,
      topLevelIds,
      excludeValueIds,
    } = this.state;

    if (!selectedValueIds?.length) {
      await this.setState({ selectedValueIds: topLevelIds });
    }
    // alert(topLevelIds.includes(id));
    // graphValues = graphValues.filter((g) => g.value.id !== id);
    // graphValueIds = graphValueIds.filter((g) => g !== id);
    // this.setState({ graphValues, graphValueIds });

    // topLevelIds = topLevelIds.filter((g) => g !== id);
    excludeValueIds.push(id);

    await this.setState({
      focusedValueId: null,
      excludeValueIds: excludeValueIds,
    });
    this.fetch();
  };

  addGraphValue = async (id) => {
    let { graphValueIds, topLevelIds, selectedValueIds, excludeValueIds } =
      this.state;
    // if (graphValueIds.includes(id)) {
    //   this.removeGraphValue(id);
    //   return;
    // } else {
    //   graphValueIds.push(id);
    //   await this.setState({ graphValueIds });
    //   // this.fetchGraphValues();
    //   this.fetch();
    // }
    if (selectedValueIds.includes(id)) {
      this.removeGraphValue(id);
      return;
    } else {
      if (!selectedValueIds?.length) {
        selectedValueIds = topLevelIds;
      }
      selectedValueIds.push(id);
      excludeValueIds = excludeValueIds.filter((g) => g !== id);
      await this.setState({
        selectedValueIds,
        excludeValueIds,
      });
      this.fetch();
    }
  };

  fetchGraphValues = async () => {
    return;
    let { graphValues, graphValueIds } = this.state;
    for (let i = 0; i < graphValueIds.length; i++) {
      if (graphValues.find((g) => g.value.id === graphValueIds[i])) continue;
      let id = graphValueIds[i];
      this.setState({ fetchingGraphValues: true });
      let res = await valueActions.get(id, null, true);
      this.setState({
        fetchingGraphValues: false,
        graphValues: [
          ...this.state.graphValues,
          { value: res.value, moments: res.sub_moments },
        ],
      });
    }
  };

  render() {
    let {
      loading,
      startAt,
      endAt,
      chapters,
      moments,
      values,
      topLevelIds,
      selectedValue,
      graphValues,
      query,
      fetchingGraphValues,
      focusedValueId,
      selectedValueIds,
    } = this.state;

    return (
      <View style={[this.styles().container]}>
        <StatusBar style="auto" />

        <View style={{ height: this.context.sizes.base }} />

        <ScrollView style={this.styles().scroller}>
          {loading && <ActivityIndicator />}

          <Autocomplete
            placeholder={"search"}
            // ref={(r) => (this.autoCompleteRef = r)}
            setRef={(r) => {
              this.autoCompleteRef = r;
            }}
            // ref={this.autoCompleteRef}
            globalSearch
            query={query || ""}
            onChangeText={(text) => {
              this.setState({ query: text });
            }}
            simpleListView
            submitFirstOnPressEnter
            onSelectItem={(value) => {
              this.addGraphValue(value.id);
              this.setState({ query: "" });
            }}
            onEnter={(value, event) => {
              if (!!value) {
                this.addGraphValue(value.id);
                this.setState({ query: "" });
              } else {
                !!this.autoCompleteRef && this.autoCompleteRef.fetchMore();
              }
            }}
            // extraItem={"Advanced Search"}
            // onPressExtraItem={() => {
            //   RootNavigation.push("AdvancedSearch", {
            //     query: this.state.query,
            //   });
            // }}
          />

          <Text>
            Selected IDS:{" "}
            {selectedValueIds.map((id) => (
              <Text onPress={() => this.removeGraphValue(id)}>{id}, </Text>
            ))}
          </Text>

          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text
              button
              onPress={async () => {
                await this.setState({ selectedValueIds: [] });
                this.fetch();
              }}
            >
              Past month
            </Text>
            <Text
              button
              onPress={() => {
                this.setState({ graphValues: [], selectedValueIds: [] });
                storageActions.clearItem("waves_selected_values");
                storageActions.clearItem("waves_excluded_values");
              }}
            >
              Clear
            </Text>
          </View>

          <View style={{ flexDirection: "row" }}>
            <DatePicker
              inputStyle={this.styles().input}
              placeholderTextColor={this.context.colors.placeholderColor}
              selected={!!startAt ? new Date(startAt) : undefined}
              value={!!startAt ? new Date(startAt) : undefined}
              onChange={(val) => {
                this.setState({ startAt: val });
              }}
              showTimeSelect={false}
            />
            <Text> – </Text>
            <DatePicker
              inputStyle={this.styles().input}
              placeholderTextColor={this.context.colors.placeholderColor}
              selected={!!endAt ? new Date(endAt) : undefined}
              value={!!endAt ? new Date(endAt) : undefined}
              onChange={(val) => {
                this.setState({ endAt: val });
              }}
              showTimeSelect={false}
            />
          </View>

          {fetchingGraphValues && (
            <View
              style={{ position: "absolute", top: 30, right: 20, zIndex: 2 }}
            >
              <ActivityIndicator />
            </View>
          )}
          {loading ? null : (
            <AreaGraph
              chapters={chapters}
              data={graphValues}
              startAt={startAt}
              endAt={endAt}
              focusedValueId={focusedValueId}
            />
          )}

          <MomentList
            showCompleted
            moments={graphValues.map((g) => ({ value: g.value }))}
            onFocusMoment={(m) => {
              this.setState({ focusedValueId: m?.value?.id });
            }}
            bonusButtonText={"Remove from Graph"}
            bonusButtonAction={async (valueId) => {
              this.removeGraphValue(valueId);
            }}
            handleDelete={async (valueId) => {
              this.removeGraphValue(valueId);
            }}
          />

          {!!graphValues?.length && (
            <Text onPress={() => this.setState({ graphValues: [] })}>
              Clear
            </Text>
          )}

          <Text>{!!startAt && `From: ${startAt}\n\n`}</Text>

          {/*{true && this.renderMomentCount()}*/}
          {true && this.renderNested()}
          <Text>{`\n\n\n\n\n`}</Text>
          {true && this.renderValuesByIds(topLevelIds)}

          {!!selectedValue && (
            <View style={{ margin: 20 }}>
              <MomentBullet
                moment={{ value: selectedValue }}
                onEscape={() => this.setState({ selectedValue: null })}
              />
            </View>
          )}
        </ScrollView>
      </View>
    );
  }

  renderValuesByIds = (ids) => {
    let allValues = this.state.values;
    let values = allValues.filter((v) => ids.includes(v.id));
    return (
      <View style={this.styles().itemWrapper}>
        {/*<Text>></Text>*/}
        <View style={this.styles().item}>
          {values.map((value) => {
            let allMoments = this.state.moments;
            let moments = allMoments.filter((m) =>
              m.value_ids.includes(value.id),
            );
            return (
              <TouchableWithoutFeedback
                key={value.id}
                onPress={() => {
                  this.setState({ selectedValue: value });
                }}
              >
                <View>
                  <Text>
                    {value.title} ({moments.length})
                  </Text>
                  {/*<Text>{value.children.length}</Text>*/}
                  {true &&
                    !!value.child_ids?.length &&
                    this.renderValuesByIds(value.child_ids)}
                </View>
              </TouchableWithoutFeedback>
            );
          })}
        </View>
      </View>
    );
  };

  renderNested = () => {
    let { nestedValues } = this.state;
    return (
      <View>
        <Text>Total: {nestedValues.length}</Text>
        {nestedValues.map((value) => {
          return (
            <View key={value.id} style={this.styles().itemWrapper}>
              <View style={this.styles().item}>
                <TouchableWithoutFeedback
                  onPress={() => {
                    this.setState({ selectedValue: value });
                  }}
                >
                  <View>
                    <Text>
                      {value.title} ({value.supportingMoments.length})
                    </Text>
                  </View>
                </TouchableWithoutFeedback>
              </View>
            </View>
          );
        })}
      </View>
    );
  };

  renderMomentCount = () => {
    let { moments, values, topLevelIds } = this.state;

    let mutatedValues = values.map((v) => {
      let value = { ...v };
      value.moments = moments.filter((m) => m.value_ids.includes(v.id));
      return value;
    });

    mutatedValues = mutatedValues.sort((a, b) => {
      let aTs = a.moments.length;
      let bTs = b.moments.length;
      if (aTs > bTs) return -1;
      if (aTs < bTs) return 1;
      return 0;
    });

    mutatedValues = mutatedValues.filter((v) => topLevelIds.includes(v.id));

    return (
      <View>
        {mutatedValues.map((value, i) => {
          // let ts = moment.completed_at || moment.updated_at;
          // ts = timeHelpers.dateTimeToDate(ts);
          let ts = ">";
          // let value = values.find((v) => moment.value_ids.includes(v.id));
          return (
            <View key={i} style={this.styles().itemWrapper}>
              <Text>
                {ts} {value.title} ({value.moments.length})
              </Text>
            </View>
          );
        })}
      </View>
    );
    return (
      <View>
        {moments.map((moment, i) => {
          let ts = moment.completed_at || moment.updated_at;
          ts = timeHelpers.dateTimeToDate(ts);
          let value = values.find((v) => moment.value_ids.includes(v.id));
          return (
            <View key={i} style={this.styles().itemWrapper}>
              <Text>
                {ts} {value.title}
              </Text>
            </View>
          );
        })}
      </View>
    );
  };

  getTopLevelIds = (values) => {
    let allValueIds = values.map((v) => v.id);
    let topLevelIds = [];
    for (let i = 0; i < values.length; i++) {
      let value = values[i];
      let hasParent = value.parent_ids.some((id) => allValueIds.includes(id));
      if (!hasParent) {
        topLevelIds.push(value.id);
      }
    }
    return topLevelIds;
  };

  nestValues = (values, moments, topLevelIds) => {
    let nestedValues = [];
    for (let i = 0; i < topLevelIds.length; i++) {
      let value = values.find((v) => v.id === topLevelIds[i]);
      value = this.nestValue(value, values, moments);
      nestedValues.push(value);
    }
    nestedValues = nestedValues.sort((n) => -n.supportingMoments.length);
    console.log(nestedValues);
    return nestedValues;
  };

  nestValue = (value, values, moments) => {
    let valueMoments = moments.filter((m) => m.value_ids.includes(value.id));
    let nestedValue = {
      ...value,
      moments: valueMoments,
      // total_moments: valueMoments.length,
      supportingMoments: valueMoments,
    };

    for (let i = 0; i < value.child_ids.length; i++) {
      let childId = value.child_ids[i];
      let child = values.find((v) => v.id === childId);
      if (child) {
        child = this.nestValue(child, values, moments);
        // nestedValue.total_moments += child.total_moments;
        nestedValue.supportingMoments = [
          ...nestedValue.supportingMoments,
          ...child.supportingMoments,
        ];
      }
    }
    return nestedValue;
  };

  styles = () => ({
    container: {
      flex: 1,
      // alignItems: 'center',
      // alignItems: 'stretch',
    },
    scroller: {
      padding: this.context.sizes.base,
    },
    itemWrapper: {
      flexDirection: "row",
    },
    item: {
      padding: 2,
      marginBottom: 5,
      marginLeft: 20,
      borderColor: this.context.colors.trim,
      // borderBottomWidth: 1,
      borderLeftWidth: 1,
    },
    input: {
      zIndex: 2,
      backgroundColor: this.context.colors.fill,
      margin: 2,
    },
  });
}
